// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module__errorMessageContainer___CVRmP {\n  text-wrap: wrap;\n  margin-bottom: 3rem;\n}\n", "",{"version":3,"sources":["webpack://screens/business-profile-page/components/edit-profile-page/styles.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,mBAAA;AACF","sourcesContent":[".errorMessageContainer {\n  text-wrap: wrap;\n  margin-bottom: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessageContainer": "styles-module__errorMessageContainer___CVRmP"
};
export default ___CSS_LOADER_EXPORT___;
